import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'jackingOpNumber',
    title: 'Jacking Op Number',
    filter: 'text'
  },
  {
    field: 'jackingOperationName',
    title: 'Jacking Activity',
    filter: 'text'
  },
  {
    field: 'dateTimeShow',
    title: 'Date',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/pages/validation/rob-figure-outstanding/rob-figure-outstanding-grid.config.ts